import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useShop from "@saleor/hooks/useShop";
import { commonMessages } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { stringifyQs } from "@saleor/utils/urls";
import React from "react";
// import { stringify as stringifyQs } from "qs";
import { useIntl } from "react-intl";

import {
  ExtraChargeTranslationInput,
  LanguageCodeEnum
} from "../../types/globalTypes";
import TranslationsExtraChargesPage, {
  fieldNames
} from "../components/TranslationsExtraChargePage";
import { TypedUpdateExtraChargeTranslations } from "../mutations";
import { TypedExtraChargeTranslationDetails } from "../queries";
import { UpdateExtraChargeTranslations } from "../types/UpdateExtraChargeTranslations";
import {
  // languageEntitiesUrl,
  languageEntityUrl,
  TranslatableEntities
} from "../urls";

export interface TranslationsExtraChargesQueryParams {
  activeField: string;
}
export interface TranslationsExtraChargesProps {
  id: string;
  languageCode: LanguageCodeEnum;
  params: TranslationsExtraChargesQueryParams;
}

const TranslationsExtraCharges: React.FC<TranslationsExtraChargesProps> = ({
  id,
  languageCode,
  params
}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const shop = useShop();
  const intl = useIntl();

  const onEdit = (field: string) =>
    navigate(
      "?" +
        stringifyQs({
          activeField: field
        }),
      true
    );
  const onUpdate = (data: UpdateExtraChargeTranslations) => {
    if (data.extraChargeTranslate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
      navigate("?", true);
    }
  };
  const onDiscard = () => {
    navigate("?", true);
  };

  return (
    <TypedExtraChargeTranslationDetails
      variables={{ id, language: languageCode }}
    >
      {extraChargeTranslations => (
        <TypedUpdateExtraChargeTranslations onCompleted={onUpdate}>
          {(updateTranslations, updateTranslationsOpts) => {
            const handleSubmit = (field: string, data: string) => {
              const input: ExtraChargeTranslationInput = {};
              if (field === fieldNames.name) {
                input.name = data;
              } else if (field === fieldNames.desc) {
                input.desc = data;
              } else if (field === fieldNames.subName) {
                input.subName = data;
              } else if (field === fieldNames.subDesc) {
                input.subDesc = data;
              }
              updateTranslations({
                variables: {
                  id,
                  input,
                  language: languageCode
                }
              });
            };

            return (
              <TranslationsExtraChargesPage
                activeField={params.activeField}
                disabled={
                  extraChargeTranslations.loading ||
                  updateTranslationsOpts.loading
                }
                languageCode={languageCode}
                languages={maybe(() => shop.languages, [])}
                saveButtonState={updateTranslationsOpts.status}
                onBack={() => history.go(-1)}
                onEdit={onEdit}
                onDiscard={onDiscard}
                onLanguageChange={lang =>
                  navigate(
                    languageEntityUrl(
                      lang,
                      TranslatableEntities.extraCharges,
                      id
                    )
                  )
                }
                onSubmit={handleSubmit}
                extraCharge={maybe(
                  () => extraChargeTranslations.data.extracharge
                )}
              />
            );
          }}
        </TypedUpdateExtraChargeTranslations>
      )}
    </TypedExtraChargeTranslationDetails>
  );
};
TranslationsExtraCharges.displayName = "TranslationsExtraCharges";
export default TranslationsExtraCharges;
